// @flow

import React from 'react';
import PropTypes from 'prop-types';
import CustomModal from '../../../../../elements/CustomModal/CustomModal';
import {Typography, makeStyles} from '@material-ui/core';

import type {Theme} from '@material-ui/core';
type Props = {
  handleClose: () => void,
  title: string,
  img: string,
};

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    width: 300,
    maxWidth: '100%',
    padding: theme.spacing(4, 1, 2, 1),
    overflowX: 'hidden',
  },
  title: {
    textAlign: 'center',
    fontSize: 18,
    [theme.breakpoints.up('md')]: {
      fontSize: 22,
    },
    color: '#313135',
    fontWeight: 600,
  },
  imgWrap: {
    marginTop: theme.spacing(2),
    width: '100%',
    maxWidth: '100%',
  },
  img: {
    maxWidth: '100%',
    width: '100%',
  },
}));
export default function InputPreview({handleClose, title, img}: Props) {
  const classes = useStyles();
  return (
    <CustomModal open handleCloseModal={handleClose}>
      <div className={classes.content}>
        <Typography variant="h2" className={classes.title}>
          {title} <br />
          Previsualización
        </Typography>

        <div className={classes.imgWrap}>
          <img src={img} alt="title" className={classes.img} />
        </div>
      </div>
    </CustomModal>
  );
}

InputPreview.propTypes = {
  handleClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
};
